module.exports = __webpack_public_path__ + "img/pnu_read_gallery1.8c976650.jpg";